import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
  selector: 'itpx-topic-subtopic-add',
  templateUrl: './topic-subtopic-add.component.html',
  styleUrls: ['./topic-subtopic-add.component.css']
})
export class TopicSubtopicAddComponent extends RxComponent implements OnInit {

    form: FormGroup;
    @Input() data;
    inputTitle: any
    private remainingCharAmount: number = 1500;
    constructor(
        private modalService: SmartModalService,
        private fb: FormBuilder) {
        super();
    }

    ngOnInit() {
        this.buildForm()
        if(this.data.node) return this.patchForm(this.data)
        this.form.controls.description.valueChanges
        .startWith(this.form.controls.description.value || '')
        .bindToLifecycle(this)
        .subscribe(
        change => {
          this.remainingCharAmount = 1500 - change.length;
        }
      );
    }

    onSubmit() {
        let result = this.form.value;
        result.id = this.data.node ? this.data.node.id : null;
        result.parent = this.data.parent ? this.data.parent.code : null;
        this.modalService.sendResult(result);
    }
    onCancel() {
        this.modalService.close();
    }

    buildForm() {
        this.inputTitle = this.data && this.data.node ? this.data.node.title : ''
        this.form = this.fb.group({
            title: [this.inputTitle, [Validators.required, Validators.maxLength(40)]],
            description: [null, [Validators.maxLength(1500)]],
            nested: [[]],
            parent: [null]
        });
    }

    patchForm(data: any): void {
        let details = data.node
        this.form.patchValue({
            title: details.title,
            description: details.description,
            nested: details.nested,
            id: details.id,
            parent: details.parent
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/topics/add/topic-subtopic-add.component.ts